import moment from 'moment';
import type { ProcessCellCallbackParams } from '../../../types/common';

const dateCellCallback = (params: ProcessCellCallbackParams): string => {
  const value: string = params.value;
  const formattedValue: string = moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : value;
  return formattedValue;
};

export default dateCellCallback;
